import { Center } from "@chakra-ui/react";
import React from "react";
import { Navigate, useParams } from "react-router-dom";

import { Alert, LoadingIndicator } from "../../../components";
import { useAiInterviewerQuery } from "../../graphql";
import Forbidden from "../../pages/forbidden/Forbidden";
import AiInterviewer from "./AiInterviewer";

const AiInterviewerDetailView: React.FC = () => {
  const { aiInterviewerId } = useParams() as { aiInterviewerId: string };

  const { loading, error, data } = useAiInterviewerQuery({
    variables: {
      aiInterviewerId,
    },
    skip: !aiInterviewerId,
  });

  if (loading) {
    return (
      <Center>
        <LoadingIndicator />
      </Center>
    );
  }

  if (error) {
    if (error.graphQLErrors.some((e) => e.extensions?.code === "FORBIDDEN")) {
      return (
        <Forbidden forbiddenFrom="AI Interviewer">
          You do not have access to this AI Interviewer.
        </Forbidden>
      );
    }
    return (
      <Alert status="error" description="Error loading AI Interviewer" reload />
    );
  }

  if (!data?.aiInterviewer) {
    return <Navigate to="/not-found" />;
  }

  return <AiInterviewer aiInterviewer={data.aiInterviewer} />;
};

export default AiInterviewerDetailView;
